module.exports = __webpack_public_path__ + "img/zhengshu102.2d504c36.jpg";